// import React, { useRef, useState, useEffect, useCallback } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPlay, faPause, faVolumeUp, faVolumeMute, faExpand, faCompress, faTimes, faBackward, faForward } from '@fortawesome/free-solid-svg-icons';
// import { toast } from 'react-toastify';
// import './VideoModal.css';
// import { useDispatch } from 'react-redux';
// import { clearEnrollments, enrollCourse } from '../../ReduxStore/EnrollSlice';
// import { COURSES_URL } from '../../Services/courseService';
// import axios from 'axios';

// const VideoModal = ({ onClose, refe }) => {
//     const { courseId } = useParams();
//     const navigate = useNavigate();
//     const [currVideo, setCurrVideo] = useState(null);
//     const [selectedVideoId, setSelectedVideoId] = useState(null);
//     const [courseData, setCourseData] = useState(null);
//     const [videos, setVideos] = useState([]);
//     const videoRef = useRef(null);
//     const videoContainerRef = useRef(null);
//     const speedButtonsRef = useRef(null);
//     const [isPaused, setIsPaused] = useState(false);
//     const [volume, setVolume] = useState(1);
//     const [progress, setProgress] = useState(0);
//     const [isFullscreen, setIsFullscreen] = useState(false);
//     const [promptVisible, setPromptVisible] = useState(false);
//     const [loginPromptVisible, setLoginPromptVisible] = useState(false);
//     const dispatch = useDispatch();
//     const userId = localStorage.getItem("userId");
//     const [playbackSpeed, setPlaybackSpeed] = useState(1);
//     const [showSpeedMenu, setShowSpeedMenu] = useState(false);

//     useEffect(() => {
//         const fetchEnrolledCourse = async () => {
//             try {
//                 const courseDetailResponse = await fetch(`${COURSES_URL}/course/${courseId}`);
//                 if (!courseDetailResponse.ok) throw new Error('Network response was not ok');
//                 const courseDetail = await courseDetailResponse.json();
//                 setCourseData(courseDetail.data);

//                 const lessonVideos = [];
//                 courseDetail?.data?.sections?.forEach(section => {
//                     section?.lessons?.forEach(lesson => {
//                         if (lesson?.videoUrl) {
//                             lessonVideos.push({ id: lesson?.id, title: lesson?.title, src: lesson?.videoUrl });
//                         }
//                     });
//                 });
//                 setVideos(lessonVideos);
//                 if (lessonVideos?.length > 0) {
//                     setCurrVideo(lessonVideos[0]?.src);
//                     setSelectedVideoId(lessonVideos[0]?.id);
//                 }
//             } catch (error) {
//                 console.error('Error fetching course data:', error);
//             }
//         };

//         fetchEnrolledCourse();
//     }, [courseId]);

//     const handleVideoChange = (video) => {
//         setCurrVideo(video?.src);
//         setSelectedVideoId(video?.id);
//         videoRef?.current?.load();
//         setIsPaused(false);
//         setPromptVisible(false);
//         setLoginPromptVisible(false);
//     };

//     const handlePlayPause = () => {
//         toast.dismiss();

//         if (!videoRef.current) {
//             toast.error("No video available to play.");
//             return;
//         }

//         if (videoRef.current.paused) {
//             videoRef.current.play();
//             setIsPaused(false);
//         } else {
//             videoRef.current.pause();
//             setIsPaused(true);
//         }
//     };

//     const handleVolumeToggle = () => {
//         toast.dismiss();

//         if (!currVideo) {
//             toast.error("No video available to adjust volume.");
//             return;
//         }

//         if (volume > 0) {
//             setVolume(0);
//             videoRef.current.volume = 0;
//         } else {
//             setVolume(1);
//             videoRef.current.volume = 1;
//         }
//     };


//     const handleForward = () => {
//         if (videoRef.current) {

//             videoRef.current.currentTime += 10;
//         }
//     }

//     const handleBackward = () => {
//         if (videoRef.current) {

//             videoRef.current.currentTime -= 10;
//         }
//     }

//     const handleKeyboardControls = useCallback((e) => {
//         if (e.key === ' ') {
//             e.preventDefault();
//             handlePlayPause();
//         } else if (e.key === 'ArrowRight') {
//             handleForward();
//         }
//         else if (e.key === 'ArrowLeft') {
//             handleBackward();
//         }
//     }, [])

//     const handleProgressUpdate = () => {
//         if (!currVideo || !videoRef.current) return;

//         const progressPercentage = (videoRef.current.currentTime / videoRef.current.duration) * 100;
//         setProgress(progressPercentage);
//     };

//     const handleProgressClick = (e) => {
//         toast.dismiss();

//         if (!currVideo) {
//             toast.error("No video available to seek.");
//             return;
//         }

//         const progressBar = e.currentTarget;
//         const clickPosition = e.clientX - progressBar.getBoundingClientRect().left;
//         const progressBarWidth = progressBar.clientWidth;
//         const newTime = (clickPosition / progressBarWidth) * videoRef.current.duration;
//         videoRef.current.currentTime = newTime;
//         setProgress((newTime / videoRef.current.duration) * 100);
//     };

//     const handleFullscreenToggle = () => {
//         toast.dismiss();

//         if (!currVideo) {
//             toast.error("No video available to enter fullscreen.");
//             return;
//         }

//         if (!isFullscreen) {
//             if (videoContainerRef.current.requestFullscreen) {
//                 videoContainerRef.current.requestFullscreen();
//             } else if (videoContainerRef.current.mozRequestFullScreen) {
//                 videoContainerRef.current.mozRequestFullScreen();
//             } else if (videoContainerRef.current.webkitRequestFullscreen) {
//                 videoContainerRef.current.webkitRequestFullscreen();
//             } else if (videoContainerRef.current.msRequestFullscreen) {
//                 videoContainerRef.current.msRequestFullscreen();
//             }
//         } else {
//             if (document.fullscreenElement) {
//                 document.exitFullscreen();
//             } else if (document.mozFullScreenElement) {
//                 document.mozCancelFullScreen();
//             } else if (document.webkitFullscreenElement) {
//                 document.webkitExitFullscreen();
//             } else if (document.msFullscreenElement) {
//                 document.msExitFullscreen();
//             }
//         }
//         setIsFullscreen(!isFullscreen);
//     };

//     const saveDemoView = async () => {
//         if (userId) {
//             try {
//                 await axios.post(`${COURSES_URL}/course/${courseId}/demo-view`, {
//                     userId: parseInt(userId),
//                 });
//                 // console.log(response.data);
//             } catch (error) {
//                 console.error('An error occurred while counting the demo view:', error);
//             }
//         } else {
//             console.log('User ID not found in localStorage. Not calling the API.');
//         }
//     };

//     const handleVideoEnd = () => {
//         if (userId) {
//             setPromptVisible(true);
//             saveDemoView();
//             setTimeout(() => setPromptVisible(false), 4000);
//         } else {
//             setLoginPromptVisible(true);
//             setTimeout(() => setLoginPromptVisible(false), 4000);
//         }
//     };

//     const handleEnrollClick = () => {
//         toast.dismiss();

//         dispatch(clearEnrollments());
//         dispatch(enrollCourse([{ courseId: courseData?.courseId, title: courseData?.title, price: courseData?.price }]));
//         toast.success('Successfully prepared for enrollment! Proceed to payment.');
//         navigate('/checkout');
//     };

//     const handleLoginClick = () => {
//         navigate('/login');
//     };

//     useEffect(() => {
//         const fullscreenChange = () => {
//             setIsFullscreen(!!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement));
//         };


//         const handleSpeedClickOutside = (e) => {
//             if (speedButtonsRef.current && !speedButtonsRef.current.contains(e.target)) {
//                 setShowSpeedMenu(false);
//             }
//         }

//         document.addEventListener('fullscreenchange', fullscreenChange);
//         document.addEventListener('webkitfullscreenchange', fullscreenChange);
//         document.addEventListener('mozfullscreenchange', fullscreenChange);
//         document.addEventListener('MSFullscreenChange', fullscreenChange);
//         document.addEventListener('keydown', handleKeyboardControls);
//         document.addEventListener('click', handleSpeedClickOutside);


//         return () => {
//             document.removeEventListener('fullscreenchange', fullscreenChange);
//             document.removeEventListener('webkitfullscreenchange', fullscreenChange);
//             document.removeEventListener('mozfullscreenchange', fullscreenChange);
//             document.removeEventListener('MSFullscreenChange', fullscreenChange);
//             document.removeEventListener('keydown', handleKeyboardControls);
//             document.removeEventListener('click', handleSpeedClickOutside);

//         };
//     }, [handleKeyboardControls]);

//     const displayedVideos = videos.slice(0, 1);
//     const handleSpeedChange = (speed) => {
//         if (videoRef.current) {
//             videoRef.current.playbackRate = speed;
//             setPlaybackSpeed(speed);
//         }
//     };

//     return (
//         <div className="video-modal-overlay">
//             <div className="video-modal-container" ref={refe}>
//                 <div className='video-top-container'>
//                     <div className='video-title-container'>
//                         <h4>Course Preview</h4>
//                         <button className="close-button" onClick={onClose}>
//                             <FontAwesomeIcon icon={faTimes} />
//                         </button>
//                     </div>
//                     <h3 className="video-title">{courseData?.title || 'Course not found'}</h3>
//                 </div>

//                 <div className="video-modal-content">
//                     {currVideo ? (
//                         <div className="custom-video-player" ref={videoContainerRef}>
//                             <video
//                                 ref={videoRef}
//                                 onTimeUpdate={handleProgressUpdate}
//                                 onEnded={handleVideoEnd}
//                                 controls={false}
//                                 autoPlay
//                                 src={currVideo}
//                             />
//                             <div className={`custom-video-controls ${isFullscreen ? 'fullscreen' : ''}`}>
//                                 <div className="progress-bar-container" onClick={handleProgressClick}>
//                                     <div className="progress-bar" style={{ width: `${progress}%` }} />
//                                 </div>

//                                 <div className='video-controls-container'>

//                                     <div className='video-controls-child'>

//                                         <button onClick={handlePlayPause} className="play-pause-btn">
//                                             <FontAwesomeIcon icon={isPaused ? faPlay : faPause} />

//                                         </button>
//                                         <button onClick={handleBackward} className="backward-btn">
//                                             <FontAwesomeIcon icon={faBackward} />
//                                         </button>


//                                         <div className="speed-controls" ref={speedButtonsRef}>
//                                             <button
//                                                 className="speed-toggle"
//                                                 onClick={() => setShowSpeedMenu(!showSpeedMenu)}
//                                             >
//                                                 {playbackSpeed}x
//                                             </button>
//                                             {showSpeedMenu && (
//                                                 <div className="speed-dropdown">
//                                                     <button onClick={() => handleSpeedChange(0.5)}>0.5x</button>
//                                                     <button onClick={() => handleSpeedChange(1)}>1x</button>
//                                                     <button onClick={() => handleSpeedChange(1.5)}>1.5x</button>
//                                                     <button onClick={() => handleSpeedChange(2)}>2x</button>
//                                                 </div>
//                                             )}
//                                         </div>
//                                         <button onClick={handleForward} className="forward-btn">
//                                             <FontAwesomeIcon icon={faForward} />
//                                         </button>
//                                         <div className="video-timestamp">
//                                             {videoRef.current && !isNaN(videoRef.current.currentTime)
//                                                 ? new Date(videoRef.current.currentTime * 1000).toISOString().substr(14, 5)
//                                                 : "00:00"}
//                                             /
//                                             {videoRef.current && !isNaN(videoRef.current.duration)
//                                                 ? new Date(videoRef.current.duration * 1000).toISOString().substr(14, 5)
//                                                 : "00:00"}
//                                         </div>
//                                     </div>


//                                     <div>

//                                         <button onClick={handleVolumeToggle} className="volume-btn">
//                                             <FontAwesomeIcon icon={volume > 0 ? faVolumeUp : faVolumeMute} />
//                                         </button>
//                                         <button onClick={handleFullscreenToggle} className="fullscreen-btn">
//                                             <FontAwesomeIcon icon={isFullscreen ? faCompress : faExpand} />
//                                         </button>
//                                     </div>
//                                 </div>


//                             </div>
//                         </div>
//                     ) : (
//                         <div className="no-video-available">
//                             <p>No video available for this course.</p>
//                         </div>
//                     )}

//                     {(promptVisible || loginPromptVisible) && (
//                         <div className="notification-prompt" onClick={promptVisible ? handleEnrollClick : handleLoginClick}>
//                             <span>
//                                 {promptVisible
//                                     ? "Unlock the full course experience—enroll now to gain access!"
//                                     : "Please log in to continue enjoying this content!"}
//                             </span>
//                             {/* <button className="close-button" onClick={()=>setPromptVisible(false)}>
//                                 <FontAwesomeIcon icon={faTimes} color='white' />
//                             </button> */}
//                         </div>
//                     )}
//                 </div>

//                 <div className="video-controls">
//                     {Array.isArray(displayedVideos) && displayedVideos?.length > 0 ? (
//                         displayedVideos.map(video => (
//                             <button
//                                 key={video?.id}
//                                 onClick={() => handleVideoChange(video)}
//                                 className={selectedVideoId === video?.id ? 'selected' : ''}
//                             >
//                                 {video?.title}
//                             </button>
//                         ))
//                     ) : (
//                         <p>No videos available.</p>
//                     )}
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default VideoModal;


import React, { useRef, useState, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlay, faPause, faVolumeUp, faVolumeMute, faExpand, faCompress, faTimes,
  faBackward, faForward
} from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import './VideoModal.css';
import { useDispatch } from 'react-redux';
import { clearEnrollments, enrollCourse } from '../../ReduxStore/EnrollSlice';
import { COURSES_URL } from '../../Services/courseService';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const VideoModal = ({ onClose, refe, courseId, courseData: passedCourseData }) => {
  const navigate = useNavigate();
  const [currVideo, setCurrVideo] = useState(null);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [courseData, setCourseData] = useState(passedCourseData?.data || null);
  const [videos, setVideos] = useState([]);
  const videoRef = useRef(null);
  const videoContainerRef = useRef(null);
  const speedButtonsRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const [volume, setVolume] = useState(1);
  const [progress, setProgress] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [promptVisible, setPromptVisible] = useState(false);
  const [loginPromptVisible, setLoginPromptVisible] = useState(false);
  const dispatch = useDispatch();
  const userId = localStorage.getItem("userId");
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [showSpeedMenu, setShowSpeedMenu] = useState(false);

  useEffect(() => {
    const fetchEnrolledCourse = async () => {
      try {
        if (!courseId) return;

        const res = await fetch(`${COURSES_URL}/course/${courseId}`);
        if (!res.ok) throw new Error("Course not found");
        const data = await res.json();
        setCourseData(data.data);

        const lessonVideos = [];
        data?.data?.sections?.forEach(section => {
          section?.lessons?.forEach(lesson => {
            if (lesson?.videoUrl) {
              lessonVideos.push({ id: lesson?.id, title: lesson?.title, src: lesson?.videoUrl });
            }
          });
        });

        setVideos(lessonVideos);
        if (lessonVideos.length > 0) {
          setCurrVideo(lessonVideos[0].src);
          setSelectedVideoId(lessonVideos[0].id);
        }

      } catch (error) {
        console.error("Error loading course:", error);
      }
    };

    if (!passedCourseData?.data) {
      fetchEnrolledCourse();
    } else {
      const lessonVideos = [];
      passedCourseData?.data?.sections?.forEach(section => {
        section?.lessons?.forEach(lesson => {
          if (lesson?.videoUrl) {
            lessonVideos.push({ id: lesson?.id, title: lesson?.title, src: lesson?.videoUrl });
          }
        });
      });

      setVideos(lessonVideos);
      if (lessonVideos.length > 0) {
        setCurrVideo(lessonVideos[0].src);
        setSelectedVideoId(lessonVideos[0].id);
      }
    }
  }, [courseId, passedCourseData]);

  const handleVideoChange = (video) => {
    setCurrVideo(video.src);
    setSelectedVideoId(video.id);
    videoRef.current?.load();
    setIsPaused(false);
    setPromptVisible(false);
    setLoginPromptVisible(false);
  };

  const handlePlayPause = () => {
    toast.dismiss();
    if (!videoRef.current) return toast.error("No video available.");
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPaused(false);
    } else {
      videoRef.current.pause();
      setIsPaused(true);
    }
  };

  const handleVolumeToggle = () => {
    toast.dismiss();
    if (!currVideo) return toast.error("No video available.");
    const newVol = volume > 0 ? 0 : 1;
    setVolume(newVol);
    videoRef.current.volume = newVol;
  };

  const handleForward = () => videoRef.current && (videoRef.current.currentTime += 10);
  const handleBackward = () => videoRef.current && (videoRef.current.currentTime -= 10);

  const handleKeyboardControls = useCallback((e) => {
    if (e.key === ' ') {
      e.preventDefault();
      handlePlayPause();
    } else if (e.key === 'ArrowRight') handleForward();
    else if (e.key === 'ArrowLeft') handleBackward();
  }, []);

  const handleProgressUpdate = () => {
    if (!currVideo || !videoRef.current) return;
    const percentage = (videoRef.current.currentTime / videoRef.current.duration) * 100;
    setProgress(percentage);
  };

  const handleProgressClick = (e) => {
    toast.dismiss();
    if (!currVideo || !videoRef.current) return toast.error("No video to seek.");
    const pos = e.clientX - e.currentTarget.getBoundingClientRect().left;
    const width = e.currentTarget.clientWidth;
    const newTime = (pos / width) * videoRef.current.duration;
    videoRef.current.currentTime = newTime;
    setProgress((newTime / videoRef.current.duration) * 100);
  };

  const handleFullscreenToggle = () => {
    toast.dismiss();
    if (!currVideo) return toast.error("No video available.");
    const container = videoContainerRef.current;
    if (!isFullscreen) {
      container.requestFullscreen?.() || container.webkitRequestFullscreen?.();
    } else {
      document.exitFullscreen?.() || document.webkitExitFullscreen?.();
    }
    setIsFullscreen(!isFullscreen);
  };

  const saveDemoView = async () => {
    if (userId) {
      try {
        await axios.post(`${COURSES_URL}/course/${courseId}/demo-view`, {
          userId: parseInt(userId),
        });
      } catch (err) {
        console.error("Demo view tracking failed:", err);
      }
    }
  };

  const handleVideoEnd = () => {
    if (userId) {
      setPromptVisible(true);
      saveDemoView();
      setTimeout(() => setPromptVisible(false), 4000);
    } else {
      setLoginPromptVisible(true);
      setTimeout(() => setLoginPromptVisible(false), 4000);
    }
  };

  const handleEnrollClick = () => {
    dispatch(clearEnrollments());
    dispatch(enrollCourse([{
      courseId: courseData?.courseId,
      title: courseData?.title,
      price: courseData?.price
    }]));
    toast.success("Ready to enroll! Proceed to payment.");
    navigate("/checkout");
  };

  const handleLoginClick = () => navigate("/login");

  useEffect(() => {
    const fullscreenChange = () => {
      const isNowFullscreen = !!(
        document.fullscreenElement || document.webkitFullscreenElement
      );
      setIsFullscreen(isNowFullscreen);
    };

    const outsideSpeedClick = (e) => {
      if (speedButtonsRef.current && !speedButtonsRef.current.contains(e.target)) {
        setShowSpeedMenu(false);
      }
    };

    document.addEventListener('fullscreenchange', fullscreenChange);
    document.addEventListener('keydown', handleKeyboardControls);
    document.addEventListener('click', outsideSpeedClick);

    return () => {
      document.removeEventListener('fullscreenchange', fullscreenChange);
      document.removeEventListener('keydown', handleKeyboardControls);
      document.removeEventListener('click', outsideSpeedClick);
    };
  }, [handleKeyboardControls]);

//   const handleSpeedChange = (speed) => {
//     videoRef.current.playbackRate = speed;
//     setPlaybackSpeed(speed);
//   };

      const displayedVideos = videos.slice(0, 1);
    const handleSpeedChange = (speed) => {
        if (videoRef.current) {
            videoRef.current.playbackRate = speed;
            setPlaybackSpeed(speed);
        }
    };

 
    return (
        <div className="video-modal-overlay">
            <div className="video-modal-container" ref={refe}>
                <div className='video-top-container'>
                    <div className='video-title-container'>
                        <h4>Course Preview</h4>
                        <button className="close-button" onClick={onClose}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                    <h3 className="video-title">{courseData?.title || 'Course not found'}</h3>
                </div>

                <div className="video-modal-content">
                    {currVideo ? (
                        <div className="custom-video-player" ref={videoContainerRef}>
                            <video
                                ref={videoRef}
                                onTimeUpdate={handleProgressUpdate}
                                onEnded={handleVideoEnd}
                                controls={false}
                                autoPlay
                                src={currVideo}
                            />
                            <div className={`custom-video-controls ${isFullscreen ? 'fullscreen' : ''}`}>
                                <div className="progress-bar-container" onClick={handleProgressClick}>
                                    <div className="progress-bar" style={{ width: `${progress}%` }} />
                                </div>

                                <div className='video-controls-container'>

                                    <div className='video-controls-child'>

                                        <button onClick={handlePlayPause} className="play-pause-btn">
                                            <FontAwesomeIcon icon={isPaused ? faPlay : faPause} />

                                        </button>
                                        <button onClick={handleBackward} className="backward-btn">
                                            <FontAwesomeIcon icon={faBackward} />
                                        </button>


                                        <div className="speed-controls" ref={speedButtonsRef}>
                                            <button
                                                className="speed-toggle"
                                                onClick={() => setShowSpeedMenu(!showSpeedMenu)}
                                            >
                                                {playbackSpeed}x
                                            </button>
                                            {showSpeedMenu && (
                                                <div className="speed-dropdown">
                                                    <button onClick={() => handleSpeedChange(0.5)}>0.5x</button>
                                                    <button onClick={() => handleSpeedChange(1)}>1x</button>
                                                    <button onClick={() => handleSpeedChange(1.5)}>1.5x</button>
                                                    <button onClick={() => handleSpeedChange(2)}>2x</button>
                                                </div>
                                            )}
                                        </div>
                                        <button onClick={handleForward} className="forward-btn">
                                            <FontAwesomeIcon icon={faForward} />
                                        </button>
                                        <div className="video-timestamp">
                                            {videoRef.current && !isNaN(videoRef.current.currentTime)
                                                ? new Date(videoRef.current.currentTime * 1000).toISOString().substr(14, 5)
                                                : "00:00"}
                                            /
                                            {videoRef.current && !isNaN(videoRef.current.duration)
                                                ? new Date(videoRef.current.duration * 1000).toISOString().substr(14, 5)
                                                : "00:00"}
                                        </div>
                                    </div>


                                    <div>

                                        <button onClick={handleVolumeToggle} className="volume-btn">
                                            <FontAwesomeIcon icon={volume > 0 ? faVolumeUp : faVolumeMute} />
                                        </button>
                                        <button onClick={handleFullscreenToggle} className="fullscreen-btn">
                                            <FontAwesomeIcon icon={isFullscreen ? faCompress : faExpand} />
                                        </button>
                                    </div>
                                </div>


                            </div>
                        </div>
                    ) : (
                        <div className="no-video-available">
                            <p>No video available for this course.</p>
                        </div>
                    )}

                    {(promptVisible || loginPromptVisible) && (
                        <div className="notification-prompt" onClick={promptVisible ? handleEnrollClick : handleLoginClick}>
                            <span>
                                {promptVisible
                                    ? "Unlock the full course experience—enroll now to gain access!"
                                    : "Please log in to continue enjoying this content!"}
                            </span>
                            {/* <button className="close-button" onClick={()=>setPromptVisible(false)}>
                                <FontAwesomeIcon icon={faTimes} color='white' />
                            </button> */}
                        </div>
                    )}
                </div>

                <div className="video-controls">
                    {Array.isArray(displayedVideos) && displayedVideos?.length > 0 ? (
                        displayedVideos.map(video => (
                            <button
                                key={video?.id}
                                onClick={() => handleVideoChange(video)}
                                className={selectedVideoId === video?.id ? 'selected' : ''}
                            >
                                {video?.title}
                            </button>
                        ))
                    ) : (
                        <p>No videos available.</p>
                    )}
                </div>

            </div>
        </div>
    );
};

export default VideoModal;
